import * as React from "react";
const SvgIndicator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10.625, cy: 10, r: 4, fill: "#EE577D" }));
export default SvgIndicator;
